const moduleMap = {
	"./host": () => {
		return Promise.all([__webpack_require__.e(9240), __webpack_require__.e(2394), __webpack_require__.e(4164), __webpack_require__.e(9864), __webpack_require__.e(4432), __webpack_require__.e(9823), __webpack_require__.e(9740), __webpack_require__.e(8115), __webpack_require__.e(9695), __webpack_require__.e(4347), __webpack_require__.e(3640)]).then(() => (() => ((__webpack_require__(5399)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});